import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ChatProvider } from "@/context/ChatContext";
import Home from "@/pages/Home";
import Result from "@/pages/Result";
import Article from "@/pages/Article";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Support from "@/pages/Support";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <ChatProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/result" element={<Result />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/support" element={<Support />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </div>
      </ChatProvider>
    </LanguageProvider>
  );
}

export default App;
